module.exports = __webpack_public_path__ + "img/waqu.52d49283.jpg";